import flow from 'lodash/flow';
import { withMedia } from 'react-media-query-hoc';
import { withAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import { withAnalyticsProvider, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import { withMediaQueryProvider } from '@domain-group/fe-allhomes-library';
import allhomesAnalyticsWrapper from './allhomes-analytics-wrapper';
import earlyAccessAnalyticsWrapper from './early-access-analytics-wrapper';
import allhomesOffMarketAnalyticsWrapper from './allhomes-off-market-analytics-wrapper';
import allhomesNielsenWrapper from './allhomes-nielsen-wrapper';
import singlePropertyPhotoPreviewWrapper from './single-property-photo-preview-wrapper';
import eventMapper from '../analytics/event-mapper';

// Separate wrapper needed, since the analytics stuff expects the legacy prop structure
export var offMarketPropertyWrapper = flow(withMedia, withMediaQueryProvider, singlePropertyPhotoPreviewWrapper, allhomesOffMarketAnalyticsWrapper, withEventBoundary(_ref => {
  var property = _ref.property;
  return {
    data: {
      property
    }
  };
}), withAllhomesContext('user'), withAnalyticsProvider(eventMapper));
export var onMarketPropertyWrapper = flow(withMedia, withMediaQueryProvider, singlePropertyPhotoPreviewWrapper, allhomesNielsenWrapper, allhomesAnalyticsWrapper, withEventBoundary(_ref2 => {
  var property = _ref2.property,
    user = _ref2.user;
  return {
    data: {
      property,
      user
    }
  };
}), withAllhomesContext('user'), withAnalyticsProvider(eventMapper));
export var earlyAccessWrapper = flow(withMedia, withMediaQueryProvider, singlePropertyPhotoPreviewWrapper, earlyAccessAnalyticsWrapper, allhomesAnalyticsWrapper, withEventBoundary(_ref3 => {
  var property = _ref3.property,
    user = _ref3.user;
  return {
    data: {
      property,
      user
    }
  };
}), withAllhomesContext('user'), withAnalyticsProvider(eventMapper));